// extracted by mini-css-extract-plugin
export default {"price":"p7-z","onSale":"q7-z","msrpLabelPrice":"r7-z","msrpLabel":"s7-z","originalPrice":"t7-z","percentOff":"u7-z"};